module.exports = __webpack_public_path__ + "static/chris-624e01254f75bddd777a76f3ce5c6e0f.png";